
// src/Database/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, setLogLevel } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";



const firebaseConfig = {
  apiKey: "AIzaSyA2upBSn75qGjWisFjP-sHt_yAIgd_ahvg",
  authDomain: "chicchiclawtutor-7fd1a.firebaseapp.com",
  projectId: "chicchiclawtutor-7fd1a",
  storageBucket: "chicchiclawtutor-7fd1a.firebasestorage.app",
  messagingSenderId: "466953260666",
  appId: "1:466953260666:web:4364fc05b5c674c6ec35c3",
  measurementId: "G-SE9BEWLJQK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// ✅ เปิด debug log
if (process.env.NODE_ENV === "development") setLogLevel("debug");

// Export services
export { app }; // ⭐ เพิ่มบรรทัดนี้

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
// ✅ เพิ่ม Functions
export const functions = getFunctions(app, "asia-southeast1");
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });